export default "__VITE_ASSET__0f4d75d5__"